import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
	FaComments,
	FaCalendarCheck,
	FaUsers,
	FaSignOutAlt,
	FaStar,
	FaCoffee,
} from 'react-icons/fa';
import style from '../css/BottomTab.module.css';

const AdminBottomTab = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const tabs = [
		{ name: 'Live Chat', path: '/chat-list', icon: <FaComments /> }, // Chat Icon
		{ name: 'Bookings', path: '/bookings', icon: <FaCalendarCheck /> }, // Calendar Check Icon
		{ name: 'Agents', path: '/agents', icon: <FaUsers /> }, // Users Icon
		{ name: 'FeedBack', path: '/feed-back', icon: <FaStar /> }, // Users Icon
		{ name: 'LogOut', path: '/', icon: <FaSignOutAlt color="red" /> }, // Sign Out Icon
	];

	return (
		<div className={style.bottomTab}>
			{tabs.map((tab) => (
				<button
					key={tab.name}
					className={`${style.tabItem} ${
						location.pathname === tab.path ? style.active : ''
					}`}
					onClick={() => navigate(tab.path)}
				>
					{tab.icon} <span>{tab.name}</span>
				</button>
			))}
		</div>
	);
};

export default AdminBottomTab;
